import { Component, OnInit } from '@angular/core';
import twitterfeeds from '../../../data/twitterfeeds.json';
import newsfeeds from '../../../data/news.json';
import testimonials from '../../../data/testimonials.json';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor(config: NgbCarouselConfig) {
    config.interval = 10000;
		config.pauseOnHover = true; }
  // Footer style
  classname = "footer-area footer-area-v1 footer-area-v3  bg_cover";
  ftlogo = "assets/images/logo-2.png";
  ftbg = "assets/images/footer-3.jpg";
  public twitterfeeds = twitterfeeds;
  public newsfeeds = newsfeeds;
  public testimonials = testimonials;
  ngOnInit(): void {
  }
  displayStyle = "none";
  
  openPopup() {
    this.displayStyle = "block";
  }
  closePopup() {
    this.displayStyle = "none";
  }

}
